import styles from './PastJobTab.module.css';
import { useNavigate } from "react-router-dom";
import { List } from "antd";
import { useEffect, useState } from "react";

import engineer from "../../assets/profile2.png";
import engineer2 from "../../assets/man1.png";
import { GoPrimitiveDot } from 'react-icons/go';
import dummyImg from '../../assets/dummy.png';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ActiveJobsMiddleware from "../../store/Middlewares/ActiveJobsMiddleware";
import { IMG_URL } from "../../store/Apis";
import moment from "moment";

const PastJobTab = () => {
  const [search, setsearch] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const PastJobs = useSelector(state => state.ActiveJobsReducer.completedJobs);
  const { t, i18n } = useTranslation();
  // console.log('Data From Reducer =======>', PastJobs);
  const PastJobsPagination = useSelector(
    state => state.ActiveJobsReducer.completedJobsPagination,
  );

  useEffect(() => {
    getPastJobs();
    getLanguage();
    console.log('past')
  }, []);

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language);
    } catch (e) {
      console.log(e);
    }
  };


  const getPastJobs = () => {
    let data = {
      next_page_url: undefined,
      Status: 'completed',
    };
    dispatch(ActiveJobsMiddleware.getCompletedJobs(data));
  };

  const onPressLoadMore = () => {
    let data = {
      next_page_url: PastJobsPagination?.links?.next,
      Status: 'completed',
    };
    dispatch(ActiveJobsMiddleware.getCompletedJobs(data));
  };

  const loadMore =
    PastJobsPagination?.links?.next ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
          display: 'flex', justifyContent: 'center'
        }}
      >
        <button onClick={onPressLoadMore} className={styles.loadMore_button}>
          Load More
        </button>
      </div>
    ) : null;


  const renderItem = (item) => {
    return (
      <div
        className={styles.box_item}
        onClick={() =>
          navigate("/jobs/PastJobs", {
            state: {...item,screen:'pastjobs'},
          })
        }
      >
        <img src={item?.customer_image ? IMG_URL + item?.customer_image : dummyImg} className={styles.image} />
        <div className={styles.heading_view}>
          <text className={styles.tab_heading}> {item?.customer_name}</text>
          <text className={styles.text}>{t(item?.location.address)}</text>
          <div className={styles.assignedDiv}>
            <div className={styles.subassignedDiv}>
              <text className={styles.text}>{item?.start_time
                ? moment('01 jan 1947 ' + item?.start_time).format(' hh:mm A')
                : ''}</text>
            </div>
            <div>
              <text className={styles.text}>{item?.date
                ? moment(item?.date).format('MM-DD-YYYY')
                : ''}</text>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className={styles.mainDiv}>

      <List
        style={{ width: "100%" }}
        grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
        dataSource={PastJobs}
        footer={loadMore}
        renderItem={renderItem}
      />
    </div>
  )
};
export default PastJobTab;